import {
  ActionStore,
  createAction,
  KeyStore,
  ObjectStore,
  on, ParamsStore,
  RemoteObjectStore,
  SOFTLINE_SERVICE_UUID,
  StoreBuilder,
  StoreFeature,
  SyncedRemoteEntityStore
} from '@softline/core';
import {Product} from '../data/product';
import {Scan} from '@softline/application';
import {ProductResourceService} from '../services/product-resource.service';
import { withLatestFrom } from 'rxjs/operators';

export interface State extends RemoteObjectStore.State<Product> { }

class ProductStoreExtension {
  static actions = {
    loadNumber: createAction<State, { number: string | number }, Product>('load number'),
    loadScan: createAction<State, { scan: Scan }, Product>('load scan')
  };

  static feature: Partial<StoreFeature<State>> = {
    actions: [
      on(ProductStoreExtension.actions.loadNumber, async ({featureName, params, injector, commit}) => {
        const service = injector.get(ProductResourceService);
        const token = injector.get(SOFTLINE_SERVICE_UUID)();
        commit(featureName, KeyStore.mutations.add, token);
        commit(featureName, ParamsStore.mutations.add, {key: token, params});

        const observable = service.validateNumber(params.number);
        const result = await ActionStore.handleObservableActionState(
          observable, featureName, commit, ProductStoreExtension.actions.loadNumber.name, token
        ).toPromise();
        commit(featureName, SyncedRemoteEntityStore.mutations.set, result);
        return result;
      }),
      on(ProductStoreExtension.actions.loadScan, async ({featureName, params, injector, commit}) => {
        const service = injector.get(ProductResourceService);
        const token = injector.get(SOFTLINE_SERVICE_UUID)();
        commit(featureName, KeyStore.mutations.add, token);
        commit(featureName, ParamsStore.mutations.add, {key: token, params});

        const observable = service.validateScan(params.scan);
        const result = await ActionStore.handleObservableActionState(
          observable, featureName, commit, ProductStoreExtension.actions.loadScan.name, token
        ).toPromise();
        commit(featureName, SyncedRemoteEntityStore.mutations.set, result);
        return result;
      })
    ]
  };
}

export const ProductStore = new StoreBuilder(RemoteObjectStore.create<Product>())
  .add(KeyStore)
  .add(ParamsStore)
  .add(ProductStoreExtension)
  .value;
